import React from 'react';
import { BadgeCheck } from 'lucide-react';

/**
 * Small "Verified Organiser" badge — a blue check circle inline with the name.
 * Props:
 *  - size: 'sm' | 'md' | 'lg'
 *  - showLabel: also render the word "Verified"
 */
const VerifiedBadge = ({ size = 'sm', showLabel = false, className = '' }) => {
  const sizes = { sm: 'w-3.5 h-3.5', md: 'w-4 h-4', lg: 'w-5 h-5' };
  return (
    <span
      className={`inline-flex items-center gap-1 text-red-500 ${className}`}
      title="Verified organiser"
      data-testid="verified-badge"
    >
      <BadgeCheck className={sizes[size] || sizes.sm} />
      {showLabel && (
        <span className="uppercase tracking-widest text-[10px] font-heading">
          Verified
        </span>
      )}
    </span>
  );
};

export default VerifiedBadge;
